<template>
    <div class="realtime-page page-gutter">
        <!-- Fullscreen loader -->
        <div v-if="isLoading" class="loader-overlay fullscreen">
            <div class="loader"></div>
        </div>
            
        <div v-if="!isLoading">
            <div class="section-head">
                <h5>{{ $t('realtime.pageTitle', { company: CompanyStore.company.CompanyName }) }}</h5>
            </div>

            <!-- Section 1 (hero): polygon-based Opportunity Funnel — where the money is. -->
            <div class="dashboard-section">
                <current-live-opportunity-data />
            </div>

            <!-- Section 2 (KPI strip + live activity tables) — context + operational view. -->
            <div class="dashboard-section">
                <current-live-visitors-data />
            </div>
        </div>

    </div>
</template>
  
<script>
import { ref, onMounted, onUnmounted, watch, defineComponent, nextTick } from 'vue'

import { useUserStore } from '@/stores/UserStore'
import { useCompanyStore } from '@/stores/CompanyStore'

import CurrentLiveVisitorsData from './CurrentLiveVisitorsData.vue'
import CurrentLiveOpportunityData from './CurrentLiveOpportunityData.vue'

export default defineComponent({
    name: 'Dashboard',

    components: {
        CurrentLiveVisitorsData,
        CurrentLiveOpportunityData,

    },

    setup() {
        const CompanyStore = useCompanyStore()
        const userStore = useUserStore()
        const controller = new AbortController()

        const isLoading = ref(true)

        onMounted(async () => {
            await userStore.fetchUserDetails()
            if (userStore.currentCompany.CompanyId) {
                await CompanyStore.fetchCompanyDetails(userStore.currentCompany.CompanyId)
            }
            isLoading.value = false
        })

        onUnmounted(() => {
            controller.abort()
        })

        return {
            CompanyStore,
            isLoading,
        }
    }
})
</script>
  
<style scoped>
.realtime-page { position: relative; }

.section-head{
    margin-top: 50px;
}

/* Each top-level section gets its own block; gap between Opportunity Funnel and the live activity area */
.dashboard-section{
  padding-top: 20px;
}
.dashboard-section:last-child{
  padding-bottom: 40px;
}

/* Fullscreen loader */
.loader-overlay.fullscreen{
  position: fixed; inset: 0; z-index: 2000;
  display: flex; align-items: center; justify-content: center;
  background: rgba(255,255,255,.8);
}
.loader {
  width: 80px; padding: 8px; aspect-ratio: 1; border-radius: 50%;
  background: #B2C149;
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m); mask: var(--_m);
  -webkit-mask-composite: source-out; mask-composite: subtract;
  animation: spinner 1s linear infinite;
}
@keyframes spinner { to { transform: rotate(1turn) } }

</style>